export const FORMAT_DATE = 'dd.MM.yyyy';
export const FORMAT_DATE_TIME = 'dd.MM.yyyy HH:mm';
export const FORMAT_TIME = 'HH:mm';
export const FORMAT_ISO_DATE = 'yyyy-MM-dd';
export const FORMAT_ISO_DATE_TIME = 'yyyy-MM-dd HH:mm';
